import { render, staticRenderFns } from "./crazyworm.vue?vue&type=template&id=1c7f1df2"
import script from "./crazyworm.vue?vue&type=script&lang=js"
export * from "./crazyworm.vue?vue&type=script&lang=js"
import style0 from "./crazyworm.vue?vue&type=style&index=0&id=1c7f1df2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports